export default "__VITE_ASSET__C4X3Kj_Y__"